

const UndoRedo = () => {
    let history = [];
    let position = 0;
  
    return {

        initPosition() {
            position = 0
            history = []
        },
        
      value() {

        return history[position];
      },
  
      setValue(value) {
        if (position < history.length ) {
          history = history.slice(0, position + 1);
        }
        history.push(value);
        position += 1;
      },

  
      undo() {
        if (position > 0) {
          position -= 1;
        }
      },
      
      redo() {
        if (position < history.length - 1) {
          position += 1;
        }
      },
  
    }
  }


  export default UndoRedo ;